// extracted by mini-css-extract-plugin
module.exports = {"listStyle":"_2r3Cbqq993BeUzm1jg7hbc"};